<template>
    <div class="stretch-layout">
        <card xs-tile sm-tile class="flex-grow-1">
            <card-text fill>
                <template v-if="impressions.length">
                    <row tight>
                        <column v-for="(impression, impressionIndex) in impressions" :key="impressionIndex" cols="6" sm="4" md="3">
                            <div class="flex items-center justify-center mb-12 cursor-pointer" @click="openImpressionByIndex(impressionIndex)">
                                <cdn-image :size="{width: 280, ratio: 1}" :src="impression.source"
                                           rounded cover
                                           :alt="impression.description"/>
                            </div>
                        </column>
                    </row>

                    <gallery-slider v-model="showImpressionModal" v-model:index="selectedImpressionIndex" :items="impressions" source-prop="source" :default-slot-height="52">
                        <div v-if="selectedImpression.description" class="p-16 absolute bottom-0 left-0 right-0 transparent-text-box">
                            <p class="text-sm text-white mb-0">Hallo Welt 12345 </p>
                        </div>
                    </gallery-slider>
                </template>
                <missing-info v-else :text="$t('missing.impression.index')" xs-tile sm-tile class="flex-grow-1"/>
            </card-text>
        </card>
    </div>
</template>

<script setup lang="ts">
import {useEventStore} from "../../../store/event";
import {EventPageType} from "@spoferan/spoferan-ts-core";

const eventStore = useEventStore();
const {t} = useI18n();
const {$api, $web} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.Impressions)) {
	await navigateTo($web('events.show', route.params.event));
}

const {data: impressions} = await useApiFetch($api('events.impressions.index', eventStore.event.id), {
	guest: true
})

const selectedImpressionIndex = ref(-1);
const showImpressionModal = ref(false);

const selectedImpression = computed(() => {
	return selectedImpressionIndex.value > -1 ? impressions[selectedImpressionIndex.value] : null;
});

function openImpressionByIndex(index) {
	if (index > -1) {
		selectedImpressionIndex.value = index;
		nextTick(function () {
			showImpressionModal.value = true;
		});
	}
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.impressions.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.impressions.index.description', {event: eventStore.event.display_name})
})
</script>

